export enum EVENT {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT'
}
